import GlobalStyle from './styles/global'
import { ThemeProvider } from 'styled-components'
import './i18next'
import theme from './styles/theme'

import Routes from './routes'

import { Provider } from 'react-redux'
import store from 'src/store'
import { TabNavigationProvider } from './contexts/TabNavigationContext'

import ToastAnimated from 'src/utils/Toast'

import { QueryClient, QueryClientProvider } from 'react-query'
import { MuiThemeProvider } from 'src/providers/MuiThemeProvider'

function App() {
  const queryClient = new QueryClient()
  return (
    <>
      <Provider store={store}>
        <TabNavigationProvider>
          <ThemeProvider theme={theme}>
            <MuiThemeProvider>
              <QueryClientProvider client={queryClient}>
                <ToastAnimated />
                <Routes />
                <GlobalStyle />
              </QueryClientProvider>
            </MuiThemeProvider>
          </ThemeProvider>
        </TabNavigationProvider>
      </Provider>
    </>
  )
}
export default App
